import { Flex } from "antd"
import { Icon } from "ui/Icon"
import { Text } from "ui/Typography"
import { useTranslation } from "react-i18next"
import { spacings } from "themes/variables"
import PropTypes from "prop-types"

const PaypalStatus = ({ isPaypalConnected }) => {
  const { t } = useTranslation()
  return (
    <Flex align="center" justify="center" gap={spacings.XXS}>
      <Icon type="feather" name={isPaypalConnected ? "Check" : "X"} width={16} height={16} />
      <Text variant="caption">{isPaypalConnected ? t("pro.settings.paypal.connected") : t("pro.settings.paypal.not_connected")}</Text>
    </Flex>
  )
}

PaypalStatus.propTypes = {
  isPaypalConnected: PropTypes.bool.isRequired
}

export default PaypalStatus
